import React from "react";
import propTypes from "prop-types";
import flex from "../../styles/flex";
import { AssetLocationTypes } from "../../logic/api";

const getColours = (percentage: number) => {
  const defaultColour = { colour: "lightgreen", textColour: "black" };

  const colourMap = new Map<
    number,
    { colour: string; textColour: string }
  >([
    [1, { colour: "red", textColour: "white" }],
    [0.99999, { colour: "orange", textColour: "black" }],
    [0, defaultColour],
  ]);

  for (const [threshold, colours] of colourMap) {
    if (threshold < percentage) {
      return colours;
    }
  }

  return defaultColour;
};

const getText = (
  value: number | null,
  total: number | null,
  percentage: number,
  displayPercentage?: boolean
) => {
  if (!total || total < 1) {
    return {
      valueToDisplay: `${value}`,
      title: `${value}`,
    };
  }

  const title = `${value} of ${total} (${(percentage * 100).toFixed(2)}%)`;
  if (displayPercentage) {
    return {
      valueToDisplay: `${(percentage * 100).toFixed(0)}%`,
      title,
    };
  }

  return {
    valueToDisplay: `${value}/${total}`,
    title,
  };
};

const CapacityBar: React.FunctionComponent<{
  total: number | null;
  value: number | null;
  displayPercentage?: boolean;
  earliestReturnDate?: string;
  assetLocationType?: AssetLocationTypes;
}> = ({ total, value, displayPercentage }) => {

  const baseWidth = 80;

  const getPercentage = () => {
    if (value && total) return value / total;
    if (value && !total) return 0;
    return 0;
  };

  const percentage = getPercentage();

  const getBarWidth = () => {
    if (value) {
      if (!total || value > total) {
        return baseWidth;
      }

      return baseWidth * percentage;
    }

    return 0;
  };

  const barWidth = getBarWidth();

  const { colour, textColour } = getColours(percentage);

  const { valueToDisplay, title } = getText(
    value,
    total,
    percentage,
    displayPercentage
  );

  return (
    <div style={{ backgroundColor: "lightgray", padding: 1.5 }}>
      <div
        title={title}
        style={{
          ...flex.flexRows,
          width: baseWidth,
          height: 15,
          backgroundColor: "#eee",
          padding: 0,
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: 11,
            color: textColour,
            fontWeight: "bold",
          }}
        >
          {valueToDisplay}
        </div>
        <div
          style={{
            ...flex.flexAuto,
            padding: 0,
            width: barWidth,
            backgroundColor: colour,
          }}
        ></div>
      </div>
    </div>
  );
};

CapacityBar.propTypes = {
  total: propTypes.number.isRequired,
  value: propTypes.number.isRequired,
};

export default CapacityBar;
